module.exports = __webpack_public_path__ + "img/icon1.d635df50.d635df50.svg";